import React from "react";
import { Remarkable } from "remarkable";

const markdown = new Remarkable();

const StepScreenshot = ({ index, currentIndex, changeIndex, text, component }) => {
  return (
    <>
      <span className={index === currentIndex ? "leftBar active" : "leftBar"} onClick={() => changeIndex(index)}>
        &nbsp;
      </span>
      <div className="gridTemplateColumn2fr" onClick={() => changeIndex(index)}>
        <div className="index">{index}</div>
        <div className="text" dangerouslySetInnerHTML={{ __html: markdown.render(text) }} />
        {component}
      </div>
    </>
  );
};

export default StepScreenshot;
